import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DeleteGoalTargetInput = {
  id: string;
  /** Goal + partner this target belonged to (cache invalidation only). */
  goalId: string;
  partnerId: string;
};

// DELETE /api/admin/goals/targets/:id
export function useDeleteGoalTarget() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, DeleteGoalTargetInput>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/goals/targets/${id}`, { method: "DELETE" }),
    onSuccess: (_data, { goalId, partnerId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.goals.targetsForGoal(goalId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.goals.detail(goalId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.goals.forPartner(partnerId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.partners.detail(partnerId),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete target");
    },
  });
}
